import React from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';

import Modal from 'components/ModalProvider/Modal/Modal';
import useAssistant from 'features/assistant/model/useAssistant';
import Spinner from 'components/Spinner/desktop';
import AssistantHeader from './components/AssistantHeader';
import Input from 'components/Input';
import SVG from 'components/SVG';

import AssistantControlPanel from './components/AssistantControlPanel';
import AssistantTable from './components/AssistantTable';

import notFoundSVG from 'shared/img/assistant-not-found.svg';

import './Assistant.scss';

const b = block('assistant');

const Assistant = () => {
  const model = useAssistant();
  const { isTableShown, actionProcessing, inputClarificationValue, parsedMessage, isEmptyParseResult } =
    model.outputState;
  const { handleInputClarificationValue, sendClarification } = model.inputState;
  const { assistantPanel: assistantLocale } = useSelector(state => state.locale.locale, shallowEqual);

  const handleKeyDown = e => {
    if (e.key === 'Enter') sendClarification();
  };

  const renderMainContent = () => {
    if (isEmptyParseResult) {
      return (
        <div className={b('empty-parse')}>
          <SVG className={b('empty-parse-icon')} svgProps={{ svg: notFoundSVG }} />
          <div className={b('empty-parse-text')}>{parsedMessage}</div>
        </div>
      );
    }
    return isTableShown ? <AssistantTable model={model} /> : <AssistantControlPanel model={model} />;
  };

  return (
    <Modal
      closeFunction={model.inputState.closeAssistant}
      content={
        <div className={b()}>
          <Spinner isLoading={actionProcessing} />
          <div className={b('content')}>
            <AssistantHeader model={model} />
            <main className={b('main', { table: isTableShown || isEmptyParseResult })}>
              {renderMainContent()}
              <div className={b('input-wrapper')}>
                <Input
                  value={inputClarificationValue}
                  onChange={e => handleInputClarificationValue(e.target.value)}
                  onKeyDown={handleKeyDown}
                  color="assistant"
                  placeholder={assistantLocale.addClarification}
                  callBack={sendClarification}
                />
              </div>
            </main>
          </div>
        </div>
      }
    />
  );
};

export default Assistant;
